import React, { forwardRef } from 'react'
import { OTISRecords, HIDDEN_GRID_COLUMNS } from './OtisHelper';
const headers = Object.entries(OTISRecords)
  .filter(
    ([key]) => !HIDDEN_GRID_COLUMNS.includes(key as (typeof HIDDEN_GRID_COLUMNS)[number])
  )
  .map(([, header]) => header);

const TableHead = forwardRef<HTMLTableSectionElement>((_, ref) => {
  return (
    <thead ref={ref} className="bg-[#f3f4f6] sticky top-0 z-10">
              <tr className="m-header">
                {headers.map((header, index) => {
                  const freezeLeft = header === "Distribution Channel/Name"
                    ? "var(--frz-l1)"
                    : header === "Organization Name/ID"
                      ? "var(--frz-l2)"
                      : header === "INITIAL ORDERS"
                        ? "var(--frz-l3)"
                        : header === "LTD\nORDERS"
                          ? "var(--frz-l4)"
                          : undefined;
                  const isFreezeColumn = freezeLeft !== undefined;
                  return (
                    <th style={{
                      whiteSpace: "pre-line",
                      textAlign: "center",
                      position: isFreezeColumn ? "sticky" : "static",
                      left: isFreezeColumn ? freezeLeft : undefined,
                      zIndex: isFreezeColumn ? 8 : 1,
                      backgroundColor: isFreezeColumn ? "#f3f4f6" : undefined,
                      borderTop: isFreezeColumn ? "1px solid #ccc" : undefined,
                      borderBottom: "1px solid #ccc",
                      borderRight: isFreezeColumn ? "2px solid #ccc" : "1px solid #ccc",
                      borderLeft: header === "Distribution Channel/Name" ? "1px solid #ccc" : undefined,
                    }}
                      key={`header-${index}`}
                      className={`font-semibold px-2 py-2 borderInputs borderInputs-top headerDivider ${header === "Distribution Channel/Name"
                        ? "borderInputs-first min-w-[150px] overflow-hidden text-ellipsis"
                        : ""
                        } ${header === "Organization Name/ID"
                          ? "min-w-[150px] overflow-hidden text-ellipsis"
                          : ""
                        } ${header === "INITIAL ORDERS"
                          ? "min-w-[100px]"
                          : ""
                        } ${header === "LTD\nORDERS"
                          ? "min-w-[100px]"
                          : ""
                        } ${header === "Account Name/ID"
                          ? "hidden"
                          : ""
                        } ${header === "Laydown Goal"
                          ? "hidden"
                          : ""
                        }`}>
                      {header
                        .replace("Pub Goal", "PUB\nGOAL")
                        .replace("Prt Mtg", "PRINT\nMEETING DATE")
                        .replace("Curr Est", "CURRENT\nESTIMATE")
                        .replace("INITIAL ORDERS", "INITIAL\nORDERS")
                        .replace("Init Ord", "INITIAL\nORDER")
                        .replace("Supp Est", "SUPPLEMENTAL\nESTIMATE")
                        .replace("Comp Init", "COMP TITLE\nINITIAL ORDER")
                        .replace("Comp Gross", "COMP TITLE\nGROSS SALES")
                        .replace("Comp Net", "COMP TITLE\nNET SALES")
                        .replace("%Ret", "COMP TITLE\n% RETURNS")
                        .replace("Cpos 4wk", "COMP TITLE\n4wk POS")
                        .replace("Cpos 8wk", "COMP TITLE\n8wk POS")
                        .replace("Cpos LTD", "COMP TITLE\nLTD POS")}
                    </th>
                  );
                })}
              </tr>
            </thead>
  )
})

TableHead.displayName = 'TableHead'

export default TableHead
